<template lang="pug">
div
  v-card(flat, v-if="biz")
    v-toolbar(flat, dense)
      .subtitle-2.mr-2 Service Items
      Info
      v-spacer
      IconBtn(@click="create()", title="Add", icon="mdi-plus")
    Table
  Form
</template>

<script>
import { EventBus } from "@/event-bus";
import { mapGetters } from "vuex";
import Form from "./Form";
import Info from "./Info";
import Table from "./Table";

export default {
  components: { Info, Table, Form },
  computed: { ...mapGetters(["biz"]) },
  methods: {
    create() {
      const item = {
        name: "",
        type: 0,
        percentage: 0,
        amount: 0,
        orderTypes: [],
      };
      EventBus.$emit("edit-service-item", item);
    },
  },
};
</script>